export default "__VITE_ASSET__BadK9iMm__"